import React from 'react';
import VouchersUI from './components/VouchersUI';

const Main = () => {
    return (
        <VouchersUI/>
    );
};

export default Main;